import Markdown from 'markdown-to-jsx';
import 'github-markdown-css/github-markdown-light.css';

type MarkdownMessageProps = {
  content: string;
};

const MarkdownMessage = ({ content }: MarkdownMessageProps) => {
  return (
    <div className='markdown-body'>
      <Markdown>{content}</Markdown>
    </div>
  );
};

export default MarkdownMessage;
